<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import api from "@/axios";
import CustomStore from 'devextreme/data/custom_store';

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter
} from 'devextreme-vue/data-grid';
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import DxButton from "devextreme-vue/button";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {

  components: {
    DxItem, DxButton, DxToolbar, Layout, PageHeader, Loader,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxPager,  DxFilterRow, DxRemoteOperations, DxHeaderFilter
  },

  data() {
    return {
      title: "DocCob's",
      items: [
        {
          text: "Financeiro",
          href: "/"
        },
        {
          text: "DocCob's",
          active: true
        }
      ],
      dataList: null,
      updating: false,
      exibEmit: true,
      exibDest: true,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,
    };
  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted docCobs-list_0')
    this.atualizaDataList()
  },

  methods: {

    atualizaDataList(){
      console.log('atualizaDataList_docCob');

      const filtros = JSON.parse(localStorage.getItem("filtros"));

      if (!filtros) {
        console.log('cookie de data não existe, criando');
        let perIniPadrao = moment(new Date()).add(-15, 'days').format('YYYY-MM-DD');
        let perFimPadrao = moment(new Date()).format('YYYY-MM-DD');
        this.dtIniFiltro = perIniPadrao;
        this.dtFimFiltro = perFimPadrao;
        localStorage.setItem('filtros', JSON.stringify({
          'doccobsdi': perIniPadrao,
          'doccobsdf': perFimPadrao,
        }));
      } else {
        this.dtIniFiltro = filtros['doccobsdi'];
        this.dtFimFiltro = filtros['doccobsdf'];
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro');
        let perIniPadrao = moment(new Date()).add(-15, 'days').format('YYYY-MM-DD');
        let perFimPadrao = moment(new Date()).format('YYYY-MM-DD');
        this.dtIniFiltro = perIniPadrao;
        this.dtFimFiltro = perFimPadrao;
      }

      const di = this.dtIniFiltro;
      const df = this.dtFimFiltro;

      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions) {
          let queryArray = [];
          if (loadOptions['filter']) {
            const processFilter = (filter) => {
              if (!filter || filter.length === 0) return;

              if (Array.isArray(filter[0])) {
                filter.forEach(item => {
                  if (Array.isArray(item)) {
                    processFilter(item);
                  }
                });
              } else {
                queryArray.push({
                  cmp: filter[0],
                  opr: filter[1],
                  val: filter[2],
                });
              }
            };
            processFilter(loadOptions['filter']);
          }

          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df,
          };

          console.log("paramsReq")
          console.log(paramsReq)
          return api.get(`${getBaseUrl()}api/doccobs`, {
            params: paramsReq
          }).then(response => {
            return {
              data: response.data[0],
              totalCount: response.data[1],
            };
          });
        },
      });
    },

    carregouGrid(e){
      console.log('carregouGrid')

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) DocCob's": ${dtIniFormated} - ${dtFimFormated}`
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'doccobsdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'doccobsdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))

      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      this.$router.push(`/doccob/editar/${idData}`)
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(248,178,58,0.82)'
              break
            case 'AT':
              corStatus = 'rgba(101,166,249,0.82)'
              break
            case 'PD':
              corStatus = 'rgba(175,117,12,0.82)'
              break
            case 'PG':
              corStatus = 'rgba(46,184,134,0.96)'
              break
            case 'NG':
              corStatus = 'rgba(223,121,106,0.98)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    nomeStatus(status) {
      switch (status.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'AT':
          return 'Autorizado(AT)'
        case 'PD':
          return 'Pendente(PD)'
        case 'PG':
          return 'Pago(PG)'
        case 'NG':
          return 'Negado(NG)'
      }
      return status.value
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

<!--        <DxItem-->
<!--            location="before"-->
<!--            widget="dxButton">-->
<!--          <DxButton-->
<!--              icon="increaselinespacing"-->
<!--              hint="Gerar Separação"-->
<!--              :on-click="relatorio"/>-->
<!--        </DxItem>-->

<!--        <DxItem-->
<!--            location="before"-->
<!--            widget="dxButton">-->
<!--          <DxButton-->
<!--              icon="plus"-->
<!--              hint="Importar arquivo de movimento"-->
<!--              text="Novo Cadastro"-->
<!--              :on-click="novaPessoa"/>-->
<!--        </DxItem>-->

      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">


      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @content-ready="carregouGrid"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strDocCobList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            sort-order="desc"
            data-field="id"
            caption="ID"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cxpostremt"
            caption="Remetente"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cxpostdest"
            caption="Destinatário"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="status"
            caption="Status"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="numfatura"
            caption="Num. Fatura"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <!--<DxColumn
            data-field="idinterc"
            caption="Intercâmbio"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>-->

        <DxColumn
            data-field="iddoc"
            caption="Documento"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cnpjtransp"
            caption="CNPJ Transp."
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="razaotransp"
            caption="Transportadora"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="numdocs"
            caption="Número CTe's Vinculados"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Criação"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[20, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>



    </div>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>

